import { ref } from 'vue'

function useUploadFile() {
    const file = ref(null)

    const readFileAsUrl = async function () {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()

            reader.onload = (res) => {
                resolve(res.target.result)
            }
            reader.onerror = (err) => reject(err)

            reader.readAsDataURL(file.value)
        })
    }

    return { file, readFileAsUrl }
}

export { useUploadFile }

export default useUploadFile
